export const buildMarkerEndValue = (markerId: string) => `url(#${markerId})`
